module.exports = __webpack_public_path__ + "img/bracket-square-right.bd6f5e7f.svg";